import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../stores/authStore';
import api from '../../services/api';
import Coin from '../../components/Coin';

const AdminReports = () => {
  const { user } = useAuthStore();
  const [reports, setReports] = useState({
    revenue: [],
    bets: [],
    users: [],
    playerStats: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const response = await api.get('/admin/reports');
      const playerStatsResponse = await api.get('/admin/player-bet-stats');
      setReports({
        revenue: response.data.revenue || [],
        bets: response.data.bets || [],
        users: response.data.users || [],
        playerStats: playerStatsResponse.data.stats || []
      });
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Rapports et Statistiques
        </h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Revenus */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Revenus
            </h2>
            <div className="space-y-4">
              <div className="flex justify-between items-center p-4 bg-green-50 rounded-lg">
                <span className="text-gray-700">Revenus totaux</span>
                <span className="text-2xl font-bold text-green-600"><Coin amount={"125,000"} symbol="HTG" /></span>
              </div>
              <div className="flex justify-between items-center p-4 bg-blue-50 rounded-lg">
                <span className="text-gray-700">Ce mois</span>
                <span className="text-xl font-semibold text-blue-600"><Coin amount={"15,000"} symbol="HTG" /></span>
              </div>
              <div className="flex justify-between items-center p-4 bg-orange-50 rounded-lg">
                <span className="text-gray-700">Cette semaine</span>
                <span className="text-lg font-semibold text-orange-600"><Coin amount={"3,500"} symbol="HTG" /></span>
              </div>
            </div>
          </div>

          {/* Paris */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Statistiques des Paris
            </h2>
            <div className="space-y-4">
              <div className="flex justify-between items-center p-4 bg-purple-50 rounded-lg">
                <span className="text-gray-700">Total des paris</span>
                <span className="text-2xl font-bold text-purple-600">1,250</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-yellow-50 rounded-lg">
                <span className="text-gray-700">Paris gagnés</span>
                <span className="text-xl font-semibold text-yellow-600">45%</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-red-50 rounded-lg">
                <span className="text-gray-700">Paris perdus</span>
                <span className="text-lg font-semibold text-red-600">55%</span>
              </div>
            </div>
          </div>

          {/* Utilisateurs */}
          {/* <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Utilisateurs
            </h2>
            {/* <div className="space-y-4">
              <div className="flex justify-between items-center p-4 bg-indigo-50 rounded-lg">
                <span className="text-gray-700">Utilisateurs totaux</span>
                <span className="text-2xl font-bold text-indigo-600">850</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-green-50 rounded-lg">
                <span className="text-gray-700">Nouveaux ce mois</span>
                <span className="text-xl font-semibold text-green-600">125</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-orange-50 rounded-lg">
                <span className="text-gray-700">Utilisateurs actifs</span>
                <span className="text-lg font-semibold text-orange-600">78%</span>
              </div>
            </div> */}
          {/* </div> */}
        </div>

        {/* Graphiques */}
        <div className="mt-8 bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Graphiques
          </h2>
          <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">Graphiques des statistiques à venir</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminReports; 
//zwing